import CircularProgress from '@mui/material/CircularProgress';
import LottieDefault from 'react-lottie';
import React from 'react';
import branclubloading from '../../../assets/lottie/brandclub_logo_load.js';
import EllipsisBlueLoading from '../../../assets/lottie/ellipsis_darkblue.js';
import EllipsisLoading from '../../../assets/lottie/ellipsis.js';

const Lottie = LottieDefault;
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: branclubloading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
const ellipsisBlueOptions = {
    loop: true,
    autoplay: true,
    animationData: EllipsisBlueLoading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
const ellipsisOptions = {
    loop: true,
    autoplay: true,
    animationData: EllipsisLoading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
const Loading = ({ star, ellipsisBlue, size, ellipsis }) => {
    return (React.createElement("div", { style: {
            position: 'relative',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        } }, ellipsisBlue ? (React.createElement(Lottie, { options: ellipsisBlueOptions, isClickToPauseDisabled: true, width: size !== null && size !== void 0 ? size : 30, height: size !== null && size !== void 0 ? size : 30 })) : ellipsis ? (React.createElement(Lottie, { options: ellipsisOptions, isClickToPauseDisabled: true, width: size !== null && size !== void 0 ? size : 30, height: size !== null && size !== void 0 ? size : 30 })) : star ? (React.createElement(Lottie, { options: defaultOptions, width: 200 })) : (React.createElement(CircularProgress, { size: 100 }))));
};
const ButtonLoadingEllipsis = ({ baseFontSize = 12, blue }) => {
    const ellipsisContainerSize = baseFontSize * 1.4;
    const ellipsisSize = baseFontSize * 2.6;
    const yOffset = ellipsisSize / 10;
    return (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            width: ellipsisContainerSize,
            height: ellipsisContainerSize,
            minWidth: ellipsisContainerSize,
            minHeight: ellipsisContainerSize,
        } },
        React.createElement("div", { style: {
                position: 'absolute',
                width: ellipsisSize,
                height: ellipsisSize,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: `translateY(${yOffset}px)`,
            } },
            React.createElement(Loading, { ellipsis: !blue, ellipsisBlue: blue, size: ellipsisSize }))));
};

export { ButtonLoadingEllipsis, Loading };
//# sourceMappingURL=index.js.map
